// Mock data for Foxstone Funding - Equipment Finance Brokerage

export const company = {
  name: 'Foxstone Funding',
  tagline: 'Equipment Financing Built for Growth',
  phone: '(905) 510-5457',
  email: 'moiz@foxstonefunding.com',
  address: '3354 Hedley Rd, Burlington, ON L7M 0N6',
  responseTime: 'Hours, not days',
};

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Equipment Leasing', path: '/equipment-leasing' },
  { label: 'Business Loans', path: '/business-loans' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export const heroAdvantages = [
  {
    title: 'Fast Response',
    icon: 'Zap',
    points: [
      'Simple one-page application',
      'Streamlined approval process',
      'Get a response in hours, not days',
    ],
  },
  {
    title: 'Customer Service',
    icon: 'Users',
    points: [
      'Customer is the priority',
      'A plan that suits your needs',
      'Only business card information required',
    ],
  },
  {
    title: 'Flexibility',
    icon: 'Settings2',
    points: [
      'We finance almost all types of equipment',
      'Services only private leasing can offer',
      'Terms that work within your cashflow',
    ],
  },
];

export const services = [
  {
    id: 'commercial-leasing',
    title: 'Commercial Leasing',
    description: 'Finance all the equipment your business needs to grow.',
    image: 'https://images.unsplash.com/photo-1503708928676-1cb796a0891e?w=800&q=80',
    icon: 'Truck',
    href: '/equipment-leasing',
  },
  {
    id: 'business-loans',
    title: 'Business Loans',
    description: 'Working capital financing for your business beyond equipment.',
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80',
    icon: 'Banknote',
    href: '/business-loans',
  },
  {
    id: 'mortgage-refinancing',
    title: 'Mortgage Refinancing',
    description: 'Leverage property assets to build your business stronger.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
    icon: 'Building2',
    href: '/business-loans',
  },
];

export const leasingAdvantages = [
  {
    title: 'Accounting & Tax Advantages',
    icon: 'Calculator',
    points: [
      'Leasing offers many tax advantages \u2014 speak to your financial advisor.',
      'Sales taxes are paid on monthly payments, not upfront.',
      'Preserve capital and lines of credit for daily operations.',
      'Small monthly payments rather than a large cash outlay.',
    ],
  },
  {
    title: 'Flexible Terms',
    icon: 'CalendarRange',
    points: [
      'Payments arranged for your expected seasonal earnings.',
      'Control turnover and cost of your equipment.',
      'Financing for most used equipment with flexible age limits.',
      'Custom term structures aligned to your business model.',
    ],
  },
  {
    title: 'Variety of Options',
    icon: 'Layers',
    points: [
      'Lease to own programs.',
      'Stretch / structured lease and Fair Market Value.',
      'Pre-approvals with no obligation.',
      'Sale-leaseback and equity take-out on used equipment.',
      'Upgrade equipment by returning and trading up.',
    ],
  },
];

export const industries = [
  { name: 'Construction', icon: 'HardHat' },
  { name: 'Transportation', icon: 'Truck' },
  { name: 'Manufacturing', icon: 'Factory' },
  { name: 'Healthcare', icon: 'Stethoscope' },
  { name: 'Agriculture', icon: 'Tractor' },
  { name: 'Hospitality', icon: 'UtensilsCrossed' },
  { name: 'Technology', icon: 'Cpu' },
  { name: 'Logistics', icon: 'PackageOpen' },
];

export const testimonials = [
  {
    name: 'Marcus Reid',
    title: 'Owner, Reid Excavation',
    quote:
      'Foxstone funded two new excavators in under 48 hours. The team understood our seasonal cash flow and structured payments to match. Game-changing partnership.',
    rating: 5,
  },
  {
    name: 'Priya Shah',
    title: 'CFO, Northwind Logistics',
    quote:
      'After being turned away by our bank, Foxstone approved a full fleet refresh. Their flexibility and speed are unmatched in the industry.',
    rating: 5,
  },
  {
    name: 'Daniel Cohen',
    title: 'President, Maple Manufacturing',
    quote:
      'We have closed three deals with Foxstone in the past year. The vendor program has directly boosted our sales by 22%.',
    rating: 5,
  },
];

export const stats = [
  { label: 'Approval rate', value: '93%' },
];

export const equipmentTypes = [
  'Construction equipment',
  'Commercial vehicles & trucks',
  'CNC & machine shop tools',
  'Medical & dental equipment',
  'Restaurant equipment',
  'IT hardware & software',
  'Agricultural machinery',
  'Material handling',
  'Printing & packaging',
  'Energy & solar',
];
